import { STATIC_ICONS } from 'config/icons';

export const HelpList = {
	data: [
		{
			title: 'Plugins',
			subtitle: 'Exchange plugin',
			description: 'Access a load of plugins for smooth exchange operations',
			link: '/admin/plugins',
			img: STATIC_ICONS.RESOURCE_PLUGIN,
		},
		{
			title: 'FAQ',
			subtitle: 'Visit the HollaEx Forums to get the fastest answers',
			description:
				'Get a detailed and fast response at the HollaEx forums. Find specific and in-depth guides on exchange setup and crypto wallets tech.',
			link: 'https://www.hollaex.com/faq-and-help#hollaex-faq-section',
			img: STATIC_ICONS.RESOURCE_FAQ,
		},
		{
			title: 'Videos',
			subtitle: 'Videos on exchange and wallet technology',
			description:
				'Learn more about exchange and technology on the YouTube View Videos',
			link: 'https://www.youtube.com/channel/UCobspC2mT1Qwx2k2u5zDZiw',
			img: STATIC_ICONS.RESOURCE_VIDEOS,
		},
		{
			title: 'HollaEx Exchange',
			subtitle: 'See a live example of the HollaEx Kit in Action',
			description:
				'Official HollaEx Exchange is the home the HollaEx Token and a live example of the HollaEx Kit in action',
			link: 'https://pro.hollaex.com/trade/xht-usdt',
			img: STATIC_ICONS.RESOURCE_PRO_EXCHANGE,
		},
		{
			title: 'Other Useful Resources',
			subtitle: '',
			description: '',
			link: 'https://docs.hollaex.com/',
			img: STATIC_ICONS.RESOURCE_OTHER_RESOURCES,
		},
		{
			title: 'Status',
			subtitle: '',
			description: '',
			link: 'https://status.hollaex.com/',
			img: STATIC_ICONS.RESOURCE_STATUS,
		},
		{
			title: 'Articles',
			subtitle: '',
			description: '',
			link: 'https://www.hollaex.com/blog',
			img: STATIC_ICONS.RESOURCE_ARTICLES,
		},
		{
			title: 'API Documentation',
			subtitle: '',
			description: '',
			link: 'https://apidocs.hollaex.com',
			img: STATIC_ICONS.RESOURCE_EXPLORER,
		},
	],
};
